import { useNavigate } from "#routers/hooks";
import { linkToDeviceDetail, linkToFacilities } from "#routers/links";
import { GeocoordinateDataDisplay } from "#src/components/DataDisplay/GeocoordinateDataDisplay";
import useLocalization from "#src/hooks/useLocalization";
import { displayValueWithUnknownDataType } from "#src/utils/display";
import { KeyValuePanel, Link, Pill } from "@validereinc/common-components";
import { toTitleCaseString } from "@validereinc/utilities";
import * as PropTypes from "prop-types";
import React from "react";

const DeviceOverviewPanel = ({ deviceDetail, isLoading }) => {
  const { localize, isLoading: isMappingLoading } = useLocalization();
  const navigate = useNavigate();

  const data = [
    {
      title: "Device",
      value: (
        <Link
          onClick={() =>
            navigate({ pathname: linkToDeviceDetail(deviceDetail?.id) })
          }
          label={deviceDetail?.name ?? "-"}
        />
      ),
    },
    {
      title: localize("facility"),
      value: (
        <Link
          onClick={() =>
            navigate({ pathname: linkToFacilities(deviceDetail?.facility_id) })
          }
          label={deviceDetail?.facility?.name ?? "-"}
        />
      ),
    },
    {
      title: "Status",
      value: !isLoading ? (
        <Pill
          variant={deviceDetail.status === "active" ? "success" : "warning"}
        >
          {toTitleCaseString(deviceDetail.status ?? "-", {
            intent: "ui",
            exceptions: ["oil-and-gas"],
          })}
        </Pill>
      ) : (
        "-"
      ),
    },
    ...Object.entries(deviceDetail?.attributes ?? {}).map(
      ([key, value]: any) => ({
        key: key,
        title: toTitleCaseString(key, { intent: "ui" }),
        value:
          key !== "location" ? (
            displayValueWithUnknownDataType(value, { alignment: "right" })
          ) : (
            <GeocoordinateDataDisplay coordinates={value} />
          ),
      })
    ),
    {
      title: "Measurement Types",
      value:
        deviceDetail.measurement_types
          ?.map((type) => toTitleCaseString(type, { intent: "ui" }))
          ?.join(", ") ?? "-",
    },
  ];

  return (
    <KeyValuePanel
      panelMaxColumnCount={2}
      panelKeyValueListProps={{ maxRowCount: 6, variant: "shaded" }}
      panelProps={{
        title: "Device Details",
        loaded: !isMappingLoading && !isLoading,
      }}
      data={data}
    />
  );
};

DeviceOverviewPanel.propTypes = {
  deviceDetail: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default DeviceOverviewPanel;
